import {
    fadeIn,
    slideToggle,
    slideUp,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const tcSection = document.querySelectorAll('.tabbed-component');

    tcSection.forEach((section) => {
        const tabTitles = section.querySelectorAll('.tc-tab-item');
        const allTabContents = section.querySelectorAll('.tc-panel');
        const dropdown = section.querySelector('.tc-dropdown');
        const tabList = section.querySelector('.tc-tabs');

        if (dropdown && tabTitles.length > 0) {
            dropdown.querySelector('span').innerHTML = tabTitles[0].innerHTML;
        }

        const handleDropdownToggle = () => {
            if (window.innerWidth < 991 && dropdown) {

                dropdown.addEventListener('click', toggleDropdown);
                document.addEventListener('click', function() {
                    const allDropdowns = document.querySelectorAll('.tc-dropdown');
                    const allTabLists = document.querySelectorAll('.tc-tabs');

                    allDropdowns.forEach(drop => drop.classList.remove('is-open'));
                    allTabLists.forEach(list => slideUp(list));
                });

                tabTitles.forEach(tabTitleEle => {
                    tabTitleEle.addEventListener('click', function() {
                        if (dropdown) {
                            dropdown.querySelector('span').innerHTML = this.innerHTML;
                            dropdown.classList.remove('is-open');
                            slideUp(tabList);
                        }
                    });
                });
            } else {
                dropdown ?.removeEventListener('click', toggleDropdown);
                dropdown ?.classList.remove('is-open');
                tabList ?.removeAttribute('style');
            }
        };

        // Toggle dropdown open/close
        const toggleDropdown = function(event) {
            event.stopPropagation();
            this.classList.toggle('is-open');
            slideToggle(tabList);
        };

        // Initial dropdown toggle setup
        handleDropdownToggle();

        // Resize event listener
        window.addEventListener('resize', handleDropdownToggle);

        // Tab title click event
        tabTitles.forEach(tabTitleEle => {
            tabTitleEle.addEventListener('click', function() {
                const parent = this;
                const isOpen = parent.classList.contains('is-active');
                const targetSelector = this.dataset.href;
                const targetContent = section.querySelector('.tc-panel[data-id="' + targetSelector + '"]');

                if (isOpen) {
                    return;
                }

                const allTabItems = parent.parentElement.children;
                Array.from(allTabItems).forEach(item => item.classList.remove('is-active'));

                allTabContents.forEach(content => {
                    content.style.display = 'none';
                });

                parent.classList.add('is-active');
                if (targetContent) {
                    fadeIn(targetContent);
                }

                if (dropdown) {
                    dropdown.querySelector('span').innerHTML = this.innerHTML;
                }
            });
        });
    });
});